// SegmentsLoadGate — بوابة صريحة لحالات تحميل تعريفات الشرائح.
// v200.33 · قرار المالك: عند فشل /api/segments/definitions لا نعرض
// شرائح فارغة ولا تعريفات افتراضية ولا أصفار — نعرض الخطأ صراحةً.
//
// الاستخدام:
//   <SegmentsLoadGate>
//     <MySegmentDependentUI />
//   </SegmentsLoadGate>
//
// أثناء التحميل يعرض skeleton خفيف. عند الفشل يعرض بطاقة الرسالة الصريحة
// مع زر «إعادة المحاولة». عند النجاح يعرض الأبناء كما هم.
import React from "react";
import { useSegmentsStatus } from "../lib/useSegmentsStatus";

export default function SegmentsLoadGate({ children, label = "الشرائح" }) {
  const { status, error, retry } = useSegmentsStatus();

  if (status === "error") {
    return (
      <div
        data-testid="segments-load-error"
        role="alert"
        style={{
          background: "var(--warn-soft)",
          border: "1px solid var(--warn)",
          borderRadius: 12,
          padding: 20,
          margin: "16px 0",
          color: "var(--text)",
          direction: "rtl",
          textAlign: "right",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
          تعذّر تحميل التعريفات — لا يمكن عرض الشرائح
        </div>
        <div style={{ fontSize: 14, marginBottom: 12, opacity: 0.85 }}>
          {label} تعتمد على تعريفات الخادم canonical.
          لن يُعرض تخمين محلي. أعد المحاولة أو راجع اتصال الخادم.
        </div>
        {error?.message ? (
          <div
            data-testid="segments-load-error-detail"
            style={{ fontSize: 12, fontFamily: "monospace", opacity: 0.6, marginBottom: 12 }}
          >
            {String(error.message).slice(0, 200)}
          </div>
        ) : null}
        <button
          data-testid="segments-load-retry-btn"
          onClick={() => retry()}
          style={{
            background: "var(--warn)",
            color: "var(--card)",
            border: "none",
            borderRadius: 8,
            padding: "8px 20px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          إعادة المحاولة
        </button>
      </div>
    );
  }

  if (status === "loading" || status === "idle") {
    return (
      <div
        data-testid="segments-load-loading"
        style={{
          padding: 20,
          margin: "16px 0",
          color: "var(--muted, #78716c)",
          direction: "rtl",
          textAlign: "right",
          fontSize: 14,
        }}
      >
        جارٍ تحميل تعريفات الشرائح من الخادم…
      </div>
    );
  }

  return <>{children}</>;
}
